import React, { useEffect } from "react";
import { Flex } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignUp, useAuth } from "./clerkReact";
import { getConfigValue } from "../../config/runtimeConfig";
import { appendRedirectUrl } from "./clerkRedirects";
import { useAuthProvider } from "../Authentication/AuthProviderSwitch";
import { hasClientAccess } from "../Authentication/roleAccess";

const ClerkSignUpPage = () => {
  const { isSignedIn } = useAuth();
  const { has, orgRole } = useAuthProvider();
  const location = useLocation();
  const navigate = useNavigate();
  const defaultRedirect = getConfigValue(
    "REACT_APP_CLERK_AFTER_SIGN_UP_URL",
    process.env.REACT_APP_CLERK_AFTER_SIGN_UP_URL,
    "/dashboard"
  );
  const redirectTo = location.state?.from?.pathname || defaultRedirect;
  const signUpUrl = getConfigValue(
    "REACT_APP_CLERK_SIGN_UP_URL",
    process.env.REACT_APP_CLERK_SIGN_UP_URL,
    "/sign-up"
  );
  const isHostedSignUp = /^https?:\/\//i.test(signUpUrl);
  const signedInRedirect = hasClientAccess({ orgRole, has }) ? "/client/account" : redirectTo;

  useEffect(() => {
    if (!isSignedIn) return;
    navigate(signedInRedirect, { replace: true });
  }, [isSignedIn, navigate, signedInRedirect]);

  useEffect(() => {
    if (!isHostedSignUp) return;
    window.location.assign(appendRedirectUrl(signUpUrl, redirectTo));
  }, [isHostedSignUp, signUpUrl, redirectTo]);

  if (isHostedSignUp) {
    return null;
  }

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/login"
        forceRedirectUrl={redirectTo}
        fallbackRedirectUrl={redirectTo}
      />
    </Flex>
  );
};

export default ClerkSignUpPage;
